import React, { FC, ReactElement, useCallback, useContext, useEffect, useMemo, useReducer, useState } from "react";
//@ts-ignore
import { LocalizationContext } from "react-localize";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";

//types import
import { ScreenType } from "Constants";

//@ts-ignore
import sessionStorage from 'store/storages/sessionStorage';

//styles
import "./styles.sass";

import LocalizationService from "Services/localization.service";
import MvLink from "Generic/MvLink";
import { ReactAppMode } from "Interfaces/ReactAppModes";
import { EXEC_MODE } from "cfg";
import { logAnalyticData, trackAnalyticData } from "Utils/analytics";

type Props = {
    token: string;
    lang: string;
    setScreenType(screenType: ScreenType): void;
}

const GuestInfoConfirmation: FC<any> = (props: Props): ReactElement => {
    const { localize } = useContext(LocalizationContext);
    const localizationService: LocalizationService = new LocalizationService();
    const [isMobile, setIsMobile] = useState(false);

    //<p>Once complete, you&rsquo;ll receive an email confirming your transfer has been deposited into the Owner&rsquo;s account. As a reminder, this process could take up to 3 days.</p>
    const bodyString: string = localize("static.content.guest-info-confirmation-body").replace("<p>", "").replace("&rsquo;", "'").replace("&rsquo;", "'").replace("</p>", "");

    useEffect(() => {
        setIsMobile(window.screen.width <= 480);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        window.onresize = () => {
            if (window.screen.width <= 480 && !isMobile) {
                setIsMobile(true);
            }
            else if (window.screen.width > 480 && isMobile) {
              setIsMobile(false);
            }
          }
          logAnalyticData({ 
            event: 'guestNamesConfirmation', 
            siteSection: 'Points', 
            pageName:'Guest Names Confirmation', 
            website:'' 
            }, {
            ownerActivity:"Guest Names",
            ownerType: "Enrolled",
            errorMessage: "", 
        })
    }, [])

    function goToReservationPage() {
        const intMode:any = document.getElementById('intMode');
        const ownerIdforReact:any = document.getElementById('ownerIdforReact');
        const ssoTokenForReact:any = document.getElementById('ssoTokenForReact');
        const queryString: string = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const callFrom: string = urlParams.get('callFrom') || '';
    
        if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)){
            if(callFrom == "points") {
                window.location.href = '/timeshare/mvco/getUpcomingReservation?intMode='+intMode.value+'&ownerId='+ownerIdforReact.value+'&screenType=RESERVATIONS#'+ssoTokenForReact.value;
            } else {
                window.location.href = `/timeshare/mvco/getProductSummary#accordion`
            }
        } else if([ReactAppMode.VCAP].includes(EXEC_MODE)) {
            window.location.href = `/reservationActivity.jsp`;
        }
    }

    return (
        <div className={`guest-info-confirmation-page ${window.location.hostname.includes('st01.www.vacationclubap.com') && 'guest-info-confirmation-page-vcap'}`}>
            <div><img src={isMobile ? localize('static.content.guest-info-confirmation-image-mobile') : localize('static.content.guest-info-confirmation-image-desktop')} alt='' style={{ width: '100%' }} /></div>
            <br/>
            <h3 className="guest-info-confirmation-page-title">{localize("static.content.guest-info-confirmation-title")}</h3>
            <br/><br/>
            <p className="guest-info-confirmation-page-body">{bodyString}</p>
            <br/>
            <div className="transfer-point-link">
                <MvLink label={localize("static.content.guest-info-confirmation-return-to-history")} onClick={() => goToReservationPage()} />
            </div>
        </div>);
}

GuestInfoConfirmation.contextTypes = LocalizationContext;
export {
    GuestInfoConfirmation,
};